export enum Navigation {
  DETAILS = "Details",
  BANDING = "Banding",
  OUTPUT_CONFIG = "Config",
  FINAL_OUTPUT = "Final output",
}

export const Menus = [
  Navigation.DETAILS,
  Navigation.BANDING,
  Navigation.OUTPUT_CONFIG,
  Navigation.FINAL_OUTPUT
];
